import React, { useState, useRef } from "react";
import { useQuery } from "seed/gql";
import { usePost } from "seed/api";
import l from "components/util/l";
import { parseSuggestionType } from "components/collections/util/datatypes";
import View from "components/collections/forms/CollectionFormView.view";

function CollectionFormCreate({ 
  flow,
  defaultCollectionType,
  suggestions = [{
    final: {
      "name": crypto.randomUUID().replace(/-/g, ''),
      "label": `${l("Campo%CA014")} 1`,
      "type": "string",
    },
    action: "create"
  }], 
  onSave = () => {},
  closeModal = () => {},
}) {

  const params = new URLSearchParams(window.location.search);
  const collectionType = params.get("type") || defaultCollectionType || "TABLE";

  const formRef = useRef(null);
  const [error, setError] = useState(null);
  const [isGenerated, setIsGenerated] = useState(false);
  const [isPermissionsShown, setIsPermissionsShown] = useState(false);

  const hasSuggestions = (suggestions?.length ?? 0) > 0
  let initialColumns = []
  if(hasSuggestions) initialColumns = suggestions;
  const primaryKey = initialColumns.map(suggestion => suggestion.final.name)[0];

  const initialColumnsParsed = initialColumns.map(suggestion => ({
    ...suggestion,
    type: parseSuggestionType(suggestion.type)
  }));

  const [callSave, reqSave] = usePost("/collections/create_collection", {
    onCompleted: (data) => {
      onSave(data);
      closeModal();
    },
    onError: (error) => {
      if(error.status == 409) setError(l("Ya existe una tabla con ese identificador%CA015"));
      else setError(l("Ocurrió un error al crear la tabla%CA016"));
    }
  });

  const [callGenerate, reqGenerate] = usePost("/collections/generate_columns", {
    onCompleted: (data) => {
      formRef?.current.setFieldValue("structure", data.map(suggestion => ({
        initial: null,
        final: suggestion,
        action: "create"
      })));
      formRef?.current.setFieldValue("show_suggestions", true);
      setIsGenerated(true);
    }
  });

  const qCollections = useQuery(`{
		collections {
			id
			name
      uiSettings
      flow {
        name
      }
		}
	}`, `(flow.user.id=${flow?.user?.id} AND is_active=true AND flow.is_active=true AND flow.is_current_version=true)`);

  const onSubmit = (values) => {
    
    let structure = values.structure;
    const type = values.type;

    if(type == "DOCUMENT") 
      structure = [{ 
        final: { 
          name: crypto.randomUUID().replace(/-/g, ''),
          label: "Archivo",
          type: "file",
        },
        action: "create"
      }];

    if(type == "LIST")
      structure = [{
        final: { 
          name: crypto.randomUUID().replace(/-/g, ''),
          label: "Elemento",
          type: "string",
        },
        action: "create"
      }];

    callSave({
      ...values,
      flow_id: flow.id,
      structure: structure,
    });

  }

  const onGenerate = (name) => {
    callGenerate({
      flow_id: flow.id,
      name: name
      
    });
  }

  const { collections = [] } = qCollections.data || {};

  return <View
    formRef={formRef}
    flow={flow}
    collectionType={collectionType}
    isGenerated={isGenerated}
    isLoading={reqSave.loading}
    isLoadingGenerate={reqGenerate.loading}
    error={error}
    hasSuggestions={hasSuggestions}
    initialColumns={initialColumnsParsed}
    initialPrimaryKey={primaryKey}
    collections={collections}
    isPermissionsShown={isPermissionsShown}
    setIsPermissionsShown={setIsPermissionsShown}
    onSubmit={onSubmit}
    onGenerate={onGenerate}
  />;

}

export default CollectionFormCreate;